import { Button, Image, TextSize, Weight } from 'components'
import styled, { css } from 'styled-components'

import { GLOBAL_COLORS } from 'theme'

/**
 * Styling for the performance (exposure) title
 */
export const PerformanceTitle = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.big};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.64px;
  max-width: 100%;
  margin: 0;
`

/**
 * Container for the product performance content, a flex container with two columns
 */
export const PerformanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const PerformanceListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  & > div:last-child {
    border-bottom: none;
  }
`

export const PerformanceItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  border-bottom: 1px solid #d9d9d9;
  padding: 20px 0;
  gap: 20px;
`

export const PerformanceHeaders = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 20px 0;
  gap: 3px;
`

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  max-width: 364px;
  align-items: center;
`

export const ProductContainerMobile = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ProductNameAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
export const ProductTitle = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.four};
  font-weight: ${Weight.Bold};
  line-height: 130%;
`
export const ProductShortTitle = styled.span`
  text-transform: uppercase;
  font-size: ${TextSize.two};
  line-height: 130%;
  color: ${({ theme }) => theme.primaryFontColor};
  opacity: 0.4;
`

export const ProductDescription = styled.span`
  font-size: ${TextSize.small};
  line-height: 130%;
  opacity: 0.6;
`

export const ProductImageWrapper = styled.div`
  img {
    width: 41px;
    height: 41px;
  }
  ${({ theme }) => theme.mediaWidth.Desktop`
    img { 
      width: 32px;
      height: auto;
    }
  `}
`

export const ProductDelta = styled.div<{ isPositive?: boolean }>`
  color: ${({ isPositive }) =>
    isPositive
      ? css`
          ${GLOBAL_COLORS.secondaryGreen}
        `
      : css`
          ${GLOBAL_COLORS.volcanoRed}
        `};
  width: 70px;
  text-align: center;
`

export const MarketDetails = styled.div``
export const ProductDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: center;
  align-items: center;
  justify-content: center;
`

export const MarketChart = styled.div`
  width: 150px;
  text-align: center;
  height: 70px;
`

export const MarketCapHeader = styled.div`
  width: 115px;
  text-align: center;
  font-size: 12px;
  line-height: 130%;
  opacity: 0.6;
`

export const HeaderContainer = styled.div`
  width: 70px;
  text-align: center;
  font-size: 12px;
  line-height: 130%;
  opacity: 0.6;
`

export const InvestInProductButton = styled(Button)`
  width: 100%;
  height: 34px;
  margin: auto;
`
export const PerformancePageWrapper = styled.div`
  width: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 600px;
  padding: 20px 40px 0;
  margin: 0 auto;
  ${({ theme }) => theme.mediaWidth.Mobile`
   max-height: 1145px;
  `}
`
export const SkeletonWrapper = styled.div`
  width: 100%;
`
export const SkeletonWhitepaperWrapper = styled.div`
  width: 100%;
  text-align: center;
`
export const StyledHeader = styled.span`
  font-size: ${TextSize.small};
  font-style: normal;
  font-weight: ${Weight.Regular};
  line-height: 27.158px;
  opacity: 0.6;
  text-wrap: nowrap;
`

export const Polarity = styled(ProductDelta)`
  text-align: left;
`

export const LoadingTitleWrapper = styled.div`
  width: 100%;
  margin-top: 60px;
`

export const ProductImage = styled(Image)`
  width: 41px;
  height: 41px;
  border-radius: 9999px;
`
